import anutaree from "@/assets/credentials/license-anutaree.webp";
import jirapan from "@/assets/credentials/license-jirapan.webp";
import jirasak from "@/assets/credentials/license-jirasak.webp";
import patipan from "@/assets/credentials/license-patipan.webp";
import warawut from "@/assets/credentials/license-warawut.webp";
import wiwat from "@/assets/credentials/license-wiwat.webp";

import pAnutaree from "@/assets/team/anutree.webp";
import pJirapan from "@/assets/team/jirapan.webp";
import pJirasak from "@/assets/team/jirasak.webp";
import pPatipan from "@/assets/team/patipan.webp";
import pWarawut from "@/assets/team/warawut.webp";
import pWiwat from "@/assets/team/wiwat.webp";

export const LAWYERS = [
  {
    id: "wiwat",
    name: "นายวิวัฒน์",
    nameEn: "Mr. Wiwat",
    title: "Notarial Services Attorney",
    titleTh: "ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร",
    portrait: pWiwat,
    license: wiwat,
    specialties: ["Notary Public", "รับรองเอกสารระหว่างประเทศ", "MFA / Apostille"],
  },
  {
    id: "warawut",
    name: "นายวราวุธ",
    nameEn: "Mr. Warawut",
    title: "Notarial Services Attorney",
    titleTh: "ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร",
    portrait: pWarawut,
    license: warawut,
    specialties: ["Notary Public", "Embassy Legalization", "Visa Documents"],
  },
  {
    id: "patipan",
    name: "นายปฏิภาณ",
    nameEn: "Mr. Patipan",
    title: "Notarial Services Attorney",
    titleTh: "ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร",
    portrait: pPatipan,
    license: patipan,
    specialties: ["Notary Public", "นิติกรณ์กงสุล", "จดทะเบียนสมรสต่างชาติ"],
  },
  {
    id: "jirasak",
    name: "นายจิรศักดิ์",
    nameEn: "Mr. Jirasak",
    title: "Notarial Services Attorney",
    titleTh: "ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร",
    portrait: pJirasak,
    license: jirasak,
    specialties: ["Notary Public", "Corporate Documents", "Translation Certification"],
  },
  {
    id: "jirapan",
    name: "นายจิรพันธ์",
    nameEn: "Mr. Jiraphan",
    title: "Notarial Services Attorney",
    titleTh: "ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร",
    portrait: pJirapan,
    license: jirapan,
    specialties: ["Notary Public", "Police Clearance", "Background Check"],
  },
  {
    id: "anutaree",
    name: "นางสาวอนุตรีย์",
    nameEn: "Miss Anutaree",
    title: "Notarial Services Attorney",
    titleTh: "ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร",
    portrait: pAnutaree,
    license: anutaree,
    specialties: ["Notary Public", "NAATI Translation", "ยื่นวีซ่าออสเตรเลีย"],
  },
] as const;
